module.exports = __webpack_public_path__ + "media/club_deals/banner_icon-ed55f2d7.svg";